import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the students state domain
 */

const selectStudentsDomain = state => state.students || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectStudentsDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectStudentsDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectStudentsDomain,
    substate => substate.id,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectStudentsDomain,
    substate => substate.firstRender,
  );

const makeSelectItemsList = () =>
  createSelector(
    selectStudentsDomain,
    substate => substate.itemsList,
  );

const makeSelectItemsListFirstElem = () =>
  createSelector(
    selectStudentsDomain,
    substate => substate.firstElem,
    );

const makeSelectStydent = () =>
  createSelector(
    selectStudentsDomain,
    substate => substate.studentDetail,
  );

    
/**
 * Default selector used by Students
 */

const makeSelectStudents = () =>
  createSelector(
    selectStudentsDomain,
    substate => substate,
  );

export default makeSelectStudents;
export {
  selectStudentsDomain,
  makeSelectId,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectItemsList,
  makeSelectItemsListFirstElem,
  makeSelectStydent,
};
